import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "./PageWrapper";
import "./SignupCommon.css";
import DocImage from "../../assets/images/CLAYA_COL2.png";
import NationalIns from "../../assets/images/nih-logo-black1.png";
import Stanford from "../../assets/images/stanford-medicine-logo1.png";
import HarvardUni from "../../assets/images/harvard-university-logo1.png";
import WebMD from "../../assets/images/webmd-logo1.png";
import arrow from "../../assets/images/arrow.png";

const SignupPage18New: React.FC = () => {
  const navigate = useNavigate();
  const handleNext = () => {
    localStorage.setItem("step-13-completed", "true");
  };
  useEffect(() => {
    const step12Completed = localStorage.getItem("step-12-completed");
    if (step12Completed) {
      navigate("/getting-started/step-13",{ replace: true });
    } else {
      navigate("/getting-started/step-12",{ replace: true });
    }
  }, []);
  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <div className="signup-content">
          <div className="medical-institution-container">
            <p className="common-content-type" style={{ textAlign: "center" }}>
              Backed by Leading Medical Institutions
            </p>
            <div className="main-image">
              <img src={DocImage} alt="Claya Doctor" />
            </div>
            <div className="university-images">
              <div className="national-inst" style={{ background: "#FCBAA9" }}>
                <img
                  src={NationalIns}
                  alt="Weight loss"
                  className="university-img"
                />
              </div>
              <div className="national-inst" style={{ background: "#F7EEAB" }}>
                <img
                  src={Stanford}
                  alt="Weight loss"
                  className="university-img"
                />
              </div>
            </div>
            <div className="university-images">
              <div className="national-inst" style={{ background: "#DDC6F0" }}>
                <img
                  src={HarvardUni}
                  alt="Weight loss"
                  className="university-img"
                />
              </div>
              <div className="national-inst" style={{ background: "#BFDDF1" }}>
                <img src={WebMD} alt="Weight loss" className="university-img" />
              </div>
            </div>
            <div className="prescription-content">
              <span className="medication-content medic-content-bold">
                The medications that our doctors prescribe
              </span>
              <span className="medication-content medic-content-light">
                {" "}
                are recommended by Harvard, Mayo Clinic, WebMD & the National
                Institutes of Health.
              </span>
            </div>
          </div>
          <Link to="/getting-started/step-13b">
            <button onClick={handleNext} className="next-btn sticky-btn">
              Continue
              <img src={arrow} alt="Arrow" style={{ marginLeft: "8px" }} />
            </button>
          </Link>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SignupPage18New;
